var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProjects(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 22,
    viewBox: "0 0 23 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fi_2258853",
    clipPath: "url(#clip0_0_6886)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M18.4341 5.29269L14.4252 1.53632C13.9988 1.13676 13.4407 0.916748 12.8537 0.916748H5.22126C3.96038 0.916748 2.93457 1.93274 2.93457 3.18156V19.7353C2.93457 20.9841 3.96038 22.0001 5.22126 22.0001H16.8626C18.1235 22.0001 19.1493 20.9841 19.1493 19.7353V6.93793C19.1493 6.31824 18.8886 5.71856 18.4341 5.29269ZM17.2227 5.85815H14.1186C14.004 5.85815 13.9107 5.76579 13.9107 5.65226V2.75479L17.2227 5.85815ZM16.8626 20.7647H5.22126C4.64814 20.7647 4.18186 20.3029 4.18186 19.7353V3.18156C4.18186 2.61392 4.64814 2.1521 5.22126 2.1521H12.6634V5.65226C12.6634 6.44696 13.3162 7.09351 14.1186 7.09351H17.902V19.7353C17.902 20.3029 17.4357 20.7647 16.8626 20.7647Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M15.4901 13.0361H6.34337C5.99895 13.0361 5.71973 13.3127 5.71973 13.6538C5.71973 13.9949 5.99895 14.2715 6.34337 14.2715H15.4901C15.8346 14.2715 16.1138 13.9949 16.1138 13.6538C16.1138 13.3127 15.8346 13.0361 15.4901 13.0361Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M12.7401 9.40454H6.34337C5.99895 9.40454 5.71973 9.6811 5.71973 10.0222C5.71973 10.3633 5.99895 10.6399 6.34337 10.6399H12.7401C13.0846 10.6399 13.3638 10.3633 13.3638 10.0222C13.3638 9.6811 13.0846 9.40454 12.7401 9.40454Z",
    fill: "#5E5E5E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M15.4901 16.3306H6.34337C5.99895 16.3306 5.71973 16.6071 5.71973 16.9482C5.71973 17.2894 5.99895 17.5659 6.34337 17.5659H15.4901C15.8346 17.5659 16.1138 17.2894 16.1138 16.9482C16.1138 16.6071 15.8346 16.3306 15.4901 16.3306Z",
    fill: "#5E5E5E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_6886"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProjects);
export default __webpack_public_path__ + "static/media/projects.99850bc0b2f15ce09ad8fcd93a7b7333.svg";
export { ForwardRef as ReactComponent };